<template>
    <div class="app">
        <nav class="navbar header" role="navigation" aria-label="main navigation">
            <div class="container">
                <div class="navbar-brand">
                    <router-link to="/" class="navbar-item">
                        <img src="/images/nordic_logo_white.png" />
                    </router-link>

                    <a
                        role="button"
                        class="navbar-burger burger"
                        :class="{'is-active': menuOpen}"
                        @click="menuToggle"
                        aria-label="menu"
                        aria-expanded="false"
                    >
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
                </div>

                <div class="navbar-menu" :class="{'is-active': menuOpen}">
                    <div v-if="authed" class="navbar-start">
                        <router-link to="/projects" class="navbar-item">Sager</router-link>
                        <router-link v-if="$inventoryEnabled" to="/items" class="navbar-item">Lager</router-link>
                        <router-link to="/customers" class="navbar-item">Kunder</router-link>
                        <router-link v-if="$inventoryEnabled" to="/suppliers" class="navbar-item">Leverandører</router-link>
                        <router-link v-if="isAdmin" to="/rapporter" class="navbar-item">Rapporter</router-link>
                        <router-link to="/settings" class="navbar-item">Indstillinger</router-link>
                    </div>

                    <div v-if="!authed" class="navbar-end">
                        <router-link to="/login" class="navbar-item">Log ind</router-link>
                    </div>
                    <div v-if="authed" class="navbar-end">
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link">
                                {{ user.name }}
                            </a>
                            <div class="navbar-dropdown">
                                <router-link :to="{ path: '/settings/profile' }" class="navbar-item">Min profil</router-link>
                                <hr class="navbar-divider">
                                <a class="navbar-item" @click="logout">
                                    Log ud
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

        <NotificationBar v-if="notification" :type="notification.type" :msg="notification.msg" />

        <section id="content" class="section">
            <div class="container">
                <router-view :key="$route.path"></router-view>
            </div>
        </section>
        <div id="myDropzone" class="dropzone is-hidden">
            <div class="inputContainer" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NotificationBar from '@elems/NotificationBar'

export default {

    components: { NotificationBar },

    props: {
        apiToken: String,
    },

    data () {
        return {
            menuOpen: false,
        }
    },

    created() {
        if (this.apiToken) {
            this.$store.dispatch('auth', this.apiToken)
                .then(() => {
                    this.$router.push({ name: 'home' })
                })
                .catch(() => {})
        }
    },
    computed: {
        ...mapGetters(['authed', 'user', 'notification','isAdmin'])
    },
    methods: {
        logout() {
            this.$store.dispatch('setUser', null)
            this.$router.push({ name: 'login' })
        },
        menuToggle () {
            this.menuOpen = !this.menuOpen
        }
    },
}
</script>

<style lang="scss" scoped>
@import '~#/globals';
.header {
    img {
        width: 154px;
    }
}
</style>

<style lang="scss">
.navbar-burger {
    &:hover {
        color: #d2dde9;
    }
}
</style>
